<template>
    <v-row no-gutters align="center pb-2">
        <v-col no-gutters class="d-flex justify-start pl-6">
            Found 2,456 Resultsx
        </v-col>
        <v-col no-gutters class="d-flex justify-end pr-3">
            <v-pagination v-model="page" :length="15" :total-visible="5"></v-pagination> 
        </v-col>
    </v-row>
</template>

<script>
export default {
  name: "ResultsPagination",
  data: () => ({
    page: 1
  })
};
</script>

<style scoped>
    .pagination-div{
        display: block !important;
        background-color: darkcyan;
        width: 200px;
    }

    .pagination-text{
        /* width: fit-content; */
        max-width: 50%;
    }
    .pagination-button{
        /* width: fit-content; */
        max-width: 50%;
    }
</style>